var _BaseServiceV2 = require('./core/_BaseServiceV2');

module.exports = _BaseServiceV2.create('class', {
	getClassRoster: {
		cache: 'roster',
		keyProperty: 'classCode'
	},
	unEnrollStudent: {
		cache: 'roster',
		keyProperty: 'classCode'
	},
	updateClass: {
		clearCaches: ['roster']
	},
	synchronizeGoogleClassroomRoster: {
		clearCaches: ['roster']
	},
	getClasses: {
		clearCaches: ['roster']
	}
});
